
import images from "./images"

export default {
    ColorJobStatus: {
        'None Specified': {
            PathImage: images.ball.red
        },
        'Inquiring': {
            PathImage: images.ball.red
        },
        'Scheduled': {
            PathImage: images.ball.yellow
        },
        'Scheduled_not_three_days': {
            PathImage: images.ball.yellow2
        },
        'Cancelled': {
            PathImage: images.ball.red
        },
        'Not Staffed': {
            PathImage: images.ball.red
        },
        'Not Completed - CM Error': {
            PathImage: images.ball.red
        },
        'Not Completed - Laborer Error': {
            PathImage: images.ball.green
        },
        'Spam': {
            PathImage: images.ball.red
        },
        'Test Call': {
            PathImage: images.ball.green
        },
        'No Response': {
            PathImage: images.ball.red
        },
        'Refused Price': {
            PathImage: images.ball.green
        },
        'Booked Elsewhere': {
            PathImage: images.ball.green
        },
        'Completed': {
            PathImage: images.ball.green
        },
        'UHaul': {
            PathImage: [
                images["worker-white"],
                images["worker-white"],
                images["worker-white"]
            ]
        },

    },

    users: {
        colors: {
            "administrator": images.ball.red[2],
            "field_manager": images.ball.red[2],
            "crew_manager": images.ball.yellow[1],
            "laborer": images.ball.green[2],
            "worker": images.ball.green[2],
            "client": images.ball.green[2],
        }
    },
}